export function expirationPreset(preset,now=new Date()) {
  if (preset==='open') return null
  const date=new Date(now)
  if (preset==='1d' || preset==='1w') date.setDate(date.getDate()+(preset==='1w'?7:1))
  else if (preset==='1mo' || preset==='1y') {
    const day=date.getDate();date.setDate(1)
    if (preset==='1mo') date.setMonth(date.getMonth()+1)
    else date.setFullYear(date.getFullYear()+1)
    const last=new Date(date.getFullYear(),date.getMonth()+1,0).getDate()
    date.setDate(Math.min(day,last))
  } else throw new Error('Unknown expiration preset')
  return date.getTime()/1000
}
export function localDateInput(seconds) {
  if (!Number.isFinite(seconds)) return ''
  const date=new Date(seconds*1000)
  return new Date(date.getTime()-date.getTimezoneOffset()*60000).toISOString().slice(0,16)
}
